import request from './api';
import {
  API_INTRANET,
  API_NOTIFICATIONS,
  API_SHIPMENT,
  API_CMS,
  API_NOTIFICATIONS_CONTROLLER
} from '../constants/api';
import { normalizeHeader } from './normalizeResponse';

let typUser;

export const getHeader = typology =>
  request(`${API_INTRANET}menu/home?associationId=405`, {
    method: 'GET',
    params: {
      typology
    }
  }).then(response => normalizeHeader(response));

export const getHeaderMenu = typology =>
  request(`${API_INTRANET}menu/home`, {
    method: 'GET',
    params: {
      typology
    }
  }).then(response => response);

export const setTypology = typology => {
  typUser = typology;
};

export const getTypology = () => typUser;

/** NOTIFICATIONS */

export const getNotificationNewsByApp = (typeApp = '') =>
  request(`${API_NOTIFICATIONS}notificationNewsByApp`, {
    method: 'GET',
    params: {
      typeApp
    }
  });

export const getNotificationNoViewed = (typeApp, page = 0, size = 10) =>
  request(`${API_NOTIFICATIONS}noViewedByApp`, {
    method: 'GET',
    params: {
      typeApp,
      page,
      size
    }
  });

export const newGetNotificationNoViewed = ({ page = 0, size = 15 }) =>
  request(`${API_NOTIFICATIONS}noViewedByApp`, {
    method: 'GET',
    params: {
      page,
      size
    }
  });

export const checkNotNewNotification = idNotification => {
  request(`${API_NOTIFICATIONS}checkNotNew`, {
    method: 'PUT',
    params: {
      idNotification
    }
  });
};

export const checkViewedByContent = contentId =>
  request(`${API_NOTIFICATIONS}checkViewedByContentId`, {
    method: 'PUT',
    params: {
      contentId
    }
  });

export const getGifWidgetModule = () =>
  request(`${API_CMS}images/today`, {
    method: 'GET'
  });

export const getImageFromNotification = idNotification =>
  request(`${API_NOTIFICATIONS_CONTROLLER}imageFromNotificationIdNewsReviews`, {
    method: 'GET',
    params: {
      idNotificacion: idNotification
    }
  });

export const deleteNotificationById = idNotification =>
  request(`${API_NOTIFICATIONS}deleteNotification`, {
    method: 'DELETE',
    params: {
      idNotification
    }
  });

export const filterNotifications = ({
  typeApp,
  viewed,
  idNotification,
  title,
  sendDate,
  contentType,
  page,
  size
}) =>
  request(`${API_NOTIFICATIONS}filterNotification`, {
    method: 'GET',
    params: {
      typeApp,
      viewed,
      sendDate,
      idNotification,
      title,
      contentType,
      page,
      size
    }
  });

/** PARCEL NOTIFICATIONS */

export const setParcelAction = (actionUser, stateContent, contentId) =>
  request(`${API_SHIPMENT}request/status`, {
    method: 'PUT',
    params: {
      actionUser,
      stateContent,
      contentId
    }
  });

/** CMS NOTIFICATIONS */

export const setCMSAction = (contentType, action, contentId) =>
  request(`${API_CMS}${contentType}/cmscontent/${action}/${contentId}`, {
    method: 'PUT'
  });
